import { Component } from '@angular/core';
import { IntegerWidget } from 'ngx-schema-form';

@Component({
	selector: 'g-custom-integer-widget',
	templateUrl: './custom-integer-widget.component.html',
	styleUrls: ['./custom-integer-widget.component.scss'],
	standalone: false,
})
export class CustomIntegerWidgetComponent extends IntegerWidget {}
